









































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Feed from "@/components/timeline/_feed.vue";
import MemberCard from "@/components/community/_memberCard.vue";
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import Toast from "@/script/message";
import {scrollDone} from "@/script/scrollManager";
import UserAvatar from "@/components/user/_userAvatar.vue";
import GameCard from "@/components/game/_gameCard.vue";
import MetaSetting from "@/script/metaSetting";

@Component({
    components: {
        Feed,
        MemberCard,
        Swiper,
        SwiperSlide,
        UserAvatar,
        GameCard
    },
})
export default class gameList extends Vue {
    metaSetting !: MetaSetting;
    toast = new Toast();
    games: any = [];
    category: number = 1;

    //parameters
    limit: number = 20;
    offset: number = 0;
    sort: string = 'c';
    dir: string = 'asc'

    //state
    isAddData: boolean = false;
    hasData: boolean = true;


    keyword: string | (string | null)[] = '';
    TSSswiperOption = {
        slidesPerView: 8,
        spaceBetween: 0,
        breakpoints: {
            300: {
                slidesPerView: 2.5
            },
            480: {
                slidesPerView: 3.5
            },
            768: {
                slidesPerView: 4.5
            },
            992: {
                slidesPerView: 6
            },
            1200: {
                //slidesPerView: 7
            }
        }
    }

    async mounted() {

        await this.$store.dispatch("loginState");
        this.fetch()
        this.metaSetting = new MetaSetting({
            title: `${this.$t('gameList')} | Zempie.com`, //게임 리스트
            meta: [
                {name: 'description', content: `${this.$t('gameList.desc')}`},
                {property: 'og:url', content: `${this.$store.getters.homeUrl}/${this.$i18n.locale}/gameList`},
                {property: 'og:title', content: `${this.$t('gameList')} | Zempie.com`},
                {property: 'og:description', content: `${this.$t('gameList.desc')}`},
            ]
        });
        window.addEventListener("scroll", this.scrollCheck);
    }

    beforeDestroy() {
        this.$store.dispatch('resetResearchData')
        this.initData();
        window.removeEventListener("scroll", this.scrollCheck);
    }

    fetch() {
        const obj = {
            limit: this.limit,
            offset: this.offset,
            // category: this.category,
            sort: this.sort,
            dir: this.dir
        };

        this.$api.gameList(obj)
            .then((res: any) => {
                if (this.isAddData) {
                    if (res.result.games.length > 0) {
                        this.games = [...this.games, ...res.result.games]
                    }
                    else {
                        this.hasData = false
                        window.removeEventListener("scroll", this.scrollCheck);

                    }
                }
                else {
                    this.games = res.result.games;
                    this.isAddData = true
                }

            })


    }

    clickCategory(category: number) {
        this.category = category;
        this.initData();

        this.fetch();

    }


    initData() {
        window.addEventListener("scroll", this.scrollCheck);
        this.isAddData = false
        this.hasData = false
        this.limit = 20;
        this.offset = 0;
        this.games = [];
        this.sort = 'c';
        this.dir = 'asc';
    }

    scrollCheck() {
        if (scrollDone(document.documentElement)) {
            this.offset += this.limit;
            this.fetch();
        }
    }


}
